/**
 * Register the Phase 0 installability service worker (production only).
 * See docs/design/UIUX-Progressive-App-Design.md §4.3 / Epic 30 PWA-01.
 */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }
  if (!('serviceWorker' in navigator)) {
    return;
  }
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      // Installability is best-effort; never block the app shell
      console.warn('Service worker registration failed', err);
    });
  });
}
